import { cva } from 'class-variance-authority';

export const labelStyles = cva(['label', 'block'], {
  variants: {
    intent: {
      primary: ['text-body-small', 'text-blue-900', 'mb-2'],
      old: ['text-tp-body-small', 'text-blue-700', 'text-left', 'mb-3'],
    },
    required: {
      true: ['after:content-["*"]', 'after:text-red-500'],
      false: null,
    },
  },
  defaultVariants: {
    intent: 'primary',
    required: false,
  },
});